<template>
  <div class="details">
    <div class="details-content">
      <div class="details-infor">
        <div class="details-img">
          <img
            src="https://www.kfadmin.net/upload/apps_thumb/49b07408c24df7228c94c030a1ab73a1.png"
            alt=""
          />
          <div>
            <img
              src="https://www.kfadmin.net/upload/apps_thumb/49b07408c24df7228c94c030a1ab73a1.png"
              alt=""
            />
            <img
              src="https://www.kfadmin.net/upload/apps_thumb/49b07408c24df7228c94c030a1ab73a1.png"
              alt=""
            />
            <img
              src="https://www.kfadmin.net/upload/apps_thumb/49b07408c24df7228c94c030a1ab73a1.png"
              alt=""
            />
          </div>
        </div>
        <div class="particulars">
          <div class="particulars-title">
            <span>应用</span>
            <h6>【年末风口】AI创意视频生成</h6>
            <h5>版本：1.1.24 更新：2025-12-17 15:00:51</h5>
          </div>
          <div class="particulars-case">
            <div class="particulars-case-pricebox">
              <div class="particulars-case-price">
                <span>售价</span>
                <h1>￥1980</h1>
              </div>
              <div>
                <span>浏览： 20191 销量： 74</span>
              </div>
            </div>
            <div>
              <span>应用标识</span>
            </div>
            <div>
              <span>支持SASS</span>
            </div>
            <div>
              <span>支持平台</span>
            </div>
          </div>
          <div class="particulars-function">
            <span>服务周期</span>
          </div>
          <div class="particulars-function">
            <span>授权数量</span>
          </div>
          <div class="particulars-function">
            <span>安装站点</span>
          </div>
          <div class="particulars-function">
            <span>支付方式</span>
          </div>
          <div>
            <button
              type="success"
              style="width: 193px"
              class="particulars-button"
            >
              立即购买
            </button>
          </div>
        </div>
      </div>
      <div class="details-user">
        <p>开发者信息</p>
        <img
          class="head"
          src="	https://www.kfadmin.net/upload/avatar/d5fcbdb29497b05e597ae99d7c626741.png"
          alt=""
        />
        <h3>官方研发团队</h3>
        <div>
          <span>认证信息</span>
          <span class="infor-span"
            ><img src="../../assets/company.png" alt=""
          /></span>
        </div>
        <div>
          <span>入驻年限</span>
          <span class="devlopment">资深开发者</span>
        </div>
        <div class="customer-service-divider">
          <span class="customer-service-text">客服</span>
        </div>
        <div class="customer">
          <div>
            <span>售前</span>
            <span class="devlopment">
              <img src="../../assets/infor.png" alt="" />
            </span>
          </div>
          <div>
            <span>售后</span>
            <span class="devlopment"
              ><img src="../../assets/infor.png" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="details-project">
      <div class="details-project-banner">
        <ul>
          <li>项目详情</li>
          <li>需求反馈</li>
          <li>更新日志</li>
        </ul>
        <div>
          <p>一句话或一张图就能生成你想要的效果的视频！</p>
          <p>
            <img
              src="	https://www.kfadmin.net/upload/marked/ebe4193433aecc2312fafd20b9b8e5fe.jpg"
              alt=""
            />
          </p>
          <p>
            <img
              src="https://www.kfadmin.net/upload/marked/9f67652490ef0dc51718055ab7cca7b7.jpg"
              alt=""
            />
          </p>
        </div>
      </div>
      <div class="details-project-use">
        <div class="details-project-nav">他的应用</div>
        <div class="details-project-list">
          <img
            src="https://www.kfadmin.net/upload/apps_logo/49b07408c24df7228c94c030a1ab73a1.png"
            alt=""
          />
          <p>【年末风口】AI创意视频生成</p>
        </div>
        <div class="details-project-list">
          <img
            src="https://www.kfadmin.net/upload/apps_logo/53445878116ce69613f14b11c11b2b85.jpg"
            alt=""
          />
          <p>超算数字人【创新模式】</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.details {
  width: 100%;
  background-color: #f2f3f5;
  overflow: hidden;
  .particulars-button {
    width: 193px;
    height: 40px;
    padding: 12px 19px;
    border: 1px solid #1bcd63;
    background-color: #1bcd63;
    color: #fff;
    border-radius: 5px;
    padding: 12px 19px;
    margin-top: 12px;
  }
  .details-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    .details-infor {
      display: flex;
      width: 966px;
      height: 456px;
      padding: 0 30px;
      border-radius: 10px;
      background-color: #fff;
      .particulars {
        padding: 12px 30px;
        span {
          color: #909399;
          font-size: 12px;
        }
        .particulars-title {
          display: flex;
          padding-bottom: 18px;
          span {
            width: 44px;
            height: 24px;
            padding: 0 9px;
            color: #006eff;
            background-color: #ecf5ff;
            border-radius: 5px;
            font-size: 12px;
            text-align: center;
            line-height: 24px;
            box-sizing: border-box;
          }
          h6 {
            font-size: 16px;
            font-weight: 600;
            padding: 0 6px;
            width: 218px;
          }
          h6 {
            font-size: 12px;
            line-height: 22px;
            color: #909399;
          }
        }

        .particulars-case {
          width: 542px;
          height: 160px;
          padding: 12px;
          background-color: #f2f3f5;
          margin-bottom: 6px;

          .particulars-case-pricebox {
            display: flex;
            justify-content: space-between;
          }
          div {
            height: 40px;
            line-height: 40px;
          }
          .particulars-case-price {
            display: flex;
            h1 {
              color: #f56c6c;
              font-size: 30px;
            }
            span {
              line-height: 40px;
            }
          }
        }
        .particulars-function {
          height: 24px;
          padding: 6px 0;
        }
        .el-button {
          width: 193px;
          color: #ffffff !important;
        }
      }
      .details-img {
        width: 316px;
        height: 432px;
        padding: 12px;
        img {
          width: 316px;
          height: 316px;
        }
        div {
          padding-top: 12px;
          img {
            width: 56px;
            height: 56px;
            border-radius: 5px;
            margin-right: 6px;
          }
        }
      }
    }
    .details-user {
      width: 224px;
      height: 456px;
      background-color: #fff;
      margin-left: 30px;
    }
  }
  .details-project {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding: 12px;
    .details-project-banner {
      width: 1026px;
      background-color: #ffffff;
      border-radius: 6px;

      ul {
        display: flex;
        list-style: none;
        width: 100%;
        height: 43px;
        border-bottom: 1px solid #dcdfe6;

        padding: 12px 0;
        li {
          width: 56px;
          height: 19px;
          padding: 12px 18px;
          margin-right: 18px;
          font-weight: 600;
          font-size: 14px;
          &:hover {
            color: #006eff;
          }
        }
      }
      div {
        padding: 12px;
        p {
          margin: 14px 0;
          font-size: 14px;
        }
        img {
          width: 1002px;
        }
      }
    }
    .details-project-use {
      width: 200px;
      margin-left: 30px;
      background-color: #ffffff;
      border-radius: 6px;
      padding: 0 12px 12px 12px;
      .details-project-nav {
        height: 16px;
        padding: 18px;
        font-size: 12px;
        font-weight: 600;
        text-align: center;
      }
      .details-project-list {
        width: 200px;
        img {
          width: 200px;
          height: 200px;
        }
        p {
          font-size: 14px;
          text-align: center;
          margin: 14px 0;
        }
      }
    }
  }
  .customer-service-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 16px 0;
  }

  .details-user {
    span {
      color: #909399;
    }
    P {
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      height: 16px;
      padding: 18px 0;
    }
    .head {
      height: 84px;
      padding: 30px 0;
      align-self: center;
      display: block;
      margin: 0 auto;
      text-align: center;
    }
    div {
      display: flex;
      justify-content: space-around;
      height: 23px;
      padding: 6px 0;
      span {
        font-size: 12px;
      }
      .infor-span {
        width: 48px;
        text-align: center;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
    h3 {
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 12px !important;
    }
    .customer {
      display: block;
    }
    .customer-service-divider::before,
    .customer-service-divider::after {
      content: "";
      flex: 1;
      height: 1px;
      background-color: #e5e5e5;
    }

    .customer-service-text {
      padding: 0 16px;
      font-size: 14px;
      color: #666;
      cursor: pointer;
    }
  }
}
</style>